/* Drapers — persist the RFD dealer details cart attribute as the customer types,
   so the value survives cart drawer re-renders and reaches the order. */
(function () {
  'use strict';

  var SELECTOR = '[data-drapers-rfd-details] textarea';
  var DEBOUNCE_MS = 600;
  var timer = null;

  function save(value) {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'RFD dealer details': value } })
    }).then(function (res) {
      if (!res.ok) {
        console.error('[drapers-rfd-details] cart update failed:', res.status);
      }
    }).catch(function (err) {
      console.error('[drapers-rfd-details] cart update failed:', err);
    });
  }

  function onInput(event) {
    var el = event.target;
    if (!el.matches || !el.matches(SELECTOR)) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      save(el.value.trim());
      // keep any sibling instance (drawer vs cart page) in sync
      document.querySelectorAll(SELECTOR).forEach(function (other) {
        if (other !== el) other.value = el.value;
      });
    }, DEBOUNCE_MS);
  }

  // delegate so fields inside re-rendered cart drawer sections keep working
  document.addEventListener('input', onInput);
  document.addEventListener('change', onInput);
})();
